"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _ = require("lodash");
var __1 = require("../../../");
var component_1 = require("../../../component");
var element_1 = require("../../../element");
var section_1 = require("../section");
var Layer = /** @class */ (function (_super) {
    __extends(Layer, _super);
    function Layer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.outerGap = 3;
        _this.cachedInnerR = {};
        _this.cachedOuterR = {};
        _this.renderers = [];
        /** Sometimes renderers need to store shared scale (min and max value) in the layer */
        _this.rendererData = {};
        return _this;
    }
    Layer.prototype.defaultOptions = function () {
        return __assign(__assign({}, _super.prototype.defaultOptions.call(this)), { _tickCount: 0, _thickness: 70, _thicknessPerSection: null, _background: "#fff", _group: "main", _dataKeys: null });
    };
    Layer.parseAttributeValue = function (attr, value) {
        switch (attr) {
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    Layer.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this._sections = this.appendGroupT(section_1.Section).options({
            _fromAng: function (d) { return _this.circos.startAngleForChr(d._key); },
            _toAng: function (d) { return _this.circos.endAngleForChr(d._key); },
            _padAng: function (d) { return _this.circos.padAngleForChr(d._key); },
            _innerR: function (d) { return _this.getInnerR(d._key); },
            _outerR: function (d) { return _this.getOuterR(d._key); },
            _$mouseEnter: function (d) {
                d3.selectAll(".sec-" + d._key).attr("opacity", 0.8);
            },
            _$mouseLeave: function (d) {
                d3.selectAll(".sec-" + d._key).attr("opacity", 1);
            },
            class: function (d) { return "circos-section " + d._key; },
        });
    };
    Layer.prototype.prepare = function () {
        var _this = this;
        _super.prototype.prepare.call(this);
        this._sections.data(this.dataKeys.map(function (key) { return ({
            _key: key,
            data: _this.datum[key],
        }); }));
        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
            var el = _a[_i];
            if (el instanceof Renderer) {
                this.renderers.push(el);
            }
        }
    };
    Layer.prototype.postDatumUpdate = function () {
        _super.prototype.postDatumUpdate.call(this);
    };
    Object.defineProperty(Layer.prototype, "dataKeys", {
        get: function () {
            return this.getOption("_dataKeys") || Object.keys(this.datum);
        },
        enumerable: true,
        configurable: true
    });
    Layer.prototype.getScale = function (scaleKey, layerKey) {
        return this.rendererData[layerKey][scaleKey];
    };
    Layer.prototype.setScale = function (scaleKey, layerKey, min, value) {
        if (!this.rendererData[layerKey]) {
            this.rendererData[layerKey] = {};
        }
        var data = this.rendererData[layerKey];
        if (!(data[scaleKey] instanceof Array)) {
            data[scaleKey] = [undefined, undefined];
        }
        var index = min ? 0 : 1;
        var existingValue = data[scaleKey][index];
        if (typeof existingValue !== "number" || (min ? value < existingValue : value > existingValue)) {
            data[scaleKey][index] = value;
        }
    };
    Layer.prototype.getThickness = function (key) {
        if (this.hasThicknessPerSection) {
            var thickFunc = this.getOption("_thicknessPerSection", null, null, null, true);
            var funcResult = thickFunc.call(this, key);
            if (typeof funcResult === "number") {
                return funcResult;
            }
        }
        return this.getOption("_thickness");
    };
    Layer.prototype.getInnerR = function (key) {
        return this.circos.innerRForLayer(this.index, key);
    };
    Layer.prototype.getOuterR = function (key) {
        return this.circos.outerRForLayer(this.index, key);
    };
    Object.defineProperty(Layer.prototype, "hasThicknessPerSection", {
        get: function () {
            return !!this._options._thicknessPerSection;
        },
        enumerable: true,
        configurable: true
    });
    return Layer;
}(component_1.Component));
exports.Layer = Layer;
var Renderer = /** @class */ (function (_super) {
    __extends(Renderer, _super);
    function Renderer(transformer, gOptions, options, preprocessor) {
        if (gOptions === void 0) { gOptions = {}; }
        if (options === void 0) { options = {}; }
        if (preprocessor === void 0) { preprocessor = null; }
        var _this = _super.call(this) || this;
        _this.dataTransformer = transformer;
        _this.dataPreprocessor = preprocessor;
        _this._options = options || {};
        _this._gOptions = gOptions || {};
        return _this;
    }
    Renderer.prototype.prepareData = function (section) {
        this.dataTransformer = this.dataTransformer || this._getOption("_dataTransformer", (function (d) { return d; }));
        this._prepareData(section);
    };
    Renderer.prototype.renderSection = function (section) {
        var _this = this;
        this._yScale = {};
        for (var _i = 0, _a = section.parent.dataKeys; _i < _a.length; _i++) {
            var key = _a[_i];
            this._yScale[key] = this._getYScale(section, key);
        }
        if (this._options.showTicks) {
            var tickCount_1 = this._options.tickCount || 5;
            section.appendGroupT(element_1.ArcLine).options({
                _data: function (d, i, g) {
                    var _a = _this._yScale[d._key].domain(), dataMin = _a[0], dataMax = _a[1];
                    var dataThickness = (dataMax - dataMin) / tickCount_1;
                    var tickScale = __1.tool.getTickScale(dataThickness);
                    // data
                    var counter = dataMin;
                    var ticks = [];
                    while (counter < dataMax) {
                        ticks.push(_this._yScale[d._key](counter));
                        counter += tickScale;
                    }
                    return ticks.map(function (r) { return ({ r: r, _key: d._key }); });
                },
                _$beforeAll: function (d, i, g, h) {
                    var _a = section.parent.circos.xScaleForChr(d._key).range(), start = _a[0], end = _a[1];
                    h.set("start", start);
                    h.set("end", end);
                },
                _y1: function (d, i, g, h) { return h.get("start"); },
                _y2: function (d, i, g, h) { return h.get("end"); },
                _r: function (d) { return d.r; },
                fill: "none",
                stroke: "#111",
                "stroke-opacity": "0.1",
            });
        }
    };
    Renderer.prototype._prepareData = function (section) {
        var _this = this;
        var sKey = this._getOption("scaleDataKey", this.defaultScaleDataKey);
        var data = section.parent.datum;
        if (!section.parent.hasThicknessPerSection) {
            var secData = typeof this.dataPreprocessor === "function" ?
                _.mapValues(data, function (x) { return _this.dataPreprocessor(x); }) : data;
            var _a = this._getMinMax(section, null, secData), dataMin = _a[0], dataMax = _a[1];
            var min_1 = this._getOption("minValue", dataMin);
            var max_1 = this._getOption("maxValue", dataMax);
            Object.keys(data).forEach(function (key) {
                section.parent.setScale(sKey, key, true, min_1);
                section.parent.setScale(sKey, key, false, max_1);
            });
        }
        else {
            var data_1 = section.parent.datum;
            Object.keys(data_1).forEach(function (key) {
                var _a = _this._getMinMax(section, key, data_1), dataMin = _a[0], dataMax = _a[1];
                section.parent.setScale(sKey, key, true, dataMin);
                section.parent.setScale(sKey, key, false, dataMax);
            });
        }
    };
    Renderer.prototype._getMinMax = function (section, key, secData) {
        var _this = this;
        if (key === null) {
            var allData = _.flatten(_.values(secData)).filter(function (x) { return x !== undefined; });
            return d3.extent(allData, function (x) { return _this.dataTransformer(x).value; });
        }
        else {
            return d3.extent(secData[key], function (x) { return _this.dataTransformer(x).value; });
        }
    };
    Renderer.prototype._getYScale = function (section, key) {
        var innerR = this._r(true, section, key);
        var outerR = this._r(false, section, key);
        var domain;
        var sKey = this._getOption("scaleDataKey", this.defaultScaleDataKey);
        domain = section.parent.getScale(sKey, key);
        var inversed = this._getOption("inversed", false);
        return d3.scaleLinear()
            .range(inversed ? [outerR, innerR] : [innerR, outerR])
            .domain(domain);
    };
    Renderer.prototype._getOption = function (name, defaultValue) {
        if (typeof defaultValue === typeof this._options[name]) {
            return this._options[name];
        }
        else {
            return defaultValue;
        }
    };
    Renderer.prototype._r = function (inner, section, key) {
        var cachedR = section.parent[inner ? "cachedInnerR" : "cachedOuterR"];
        var cached = cachedR[key];
        if (cached) {
            return cached;
        }
        else {
            var r = inner ? section.parent.getInnerR(key) : section.parent.getOuterR(key);
            cachedR[key] = r;
            return r;
        }
    };
    Renderer.prototype._1pxDeg = function (section, key) {
        return 180 / (this._r(true, section, key) * Math.PI);
    };
    Renderer.prototype._adjustToAtLeast1Px = function (section, key, start, end) {
        var onePxDeg = this._1pxDeg(section, key);
        if (end - start < onePxDeg) {
            var mid = (start + end) / 2;
            return [mid - onePxDeg / 2, mid + onePxDeg / 2];
        }
        else {
            return [start, end];
        }
    };
    Renderer.prototype.transformData = function (data) {
        var _this = this;
        if (data.data === undefined) {
            return { _key: data._key, data: [] };
        }
        return {
            _key: data._key,
            data: (typeof this.dataPreprocessor === "function" ? this.dataPreprocessor(data.data) : data.data)
                // tslint:disable-next-line
                .map(function (x) { return Object.assign({ data: x }, _this.dataTransformer(x)); }),
        };
    };
    Renderer.prototype.assignGOptions = function (dict) {
        var _this = this;
        _.forOwn(this._gOptions, function (value, key) {
            var obj = _this[dict[key]];
            if (obj instanceof element_1.PrototypeElement) {
                obj.options(value);
            }
        });
    };
    return Renderer;
}(component_1.VirtualElement));
exports.Renderer = Renderer;
//# sourceMappingURL=base.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/circos/layers/base.js
// module id = 36
// module chunks = 0 1